export enum EditorStackRoutes {
  EDITOR = "Editor",
  SCHEDULE_CLASS_FORM = "ScheduleClassForm",
}
